import { ReportEnum } from './ReportEnum';

export const AnalyticTabs = [
  { name: 'Orders', value: ReportEnum.ORDERS },
  { name: 'Payments', value: ReportEnum.PAYMENTS },
  { name: 'Transactions', value: ReportEnum.TRANSACTIONS },
  { name: 'Users', value: ReportEnum.USERS }
];
